import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from 'react-awesome-modal';
import { List } from 'react-virtualized';
import {connect}  from  "react-redux";
import Picker from 'react-month-picker'
import MonthBox from "views/MonthBox.jsx";
import "../../assets/css/monthpicker/month-picker.css";
import { isApiResponse, isReportAccess, date_range_config, aplloClient,user_activities } from '../../helpers/utils.js';
function formatNumber (num) {
    //return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    var n1, n2;
    num = num + '' || '';
    // works for integer and floating as well
    n1 = num.split('.');
    n2 = n1[1] || null;
    n1 = n1[0].replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
    num = n2 ? n1 + '.' + n2 : n1;
    return num;
}
var minDate = new Date('2020-02-01');
var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(yesterday).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(yesterday).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(yesterday).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');
var date_limit = moment(todayDate).format('MM/DD/YYYY');
var start_date_limit = moment(minDate).format('MM/DD/YYYY');
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};
var year = new Date().getFullYear();
var mo = new Date().getMonth();
var month_val = '';
if(mo.toString().length==1){
    month_val = "" +0+mo;
}
else {
    month_val = mo;
}

var month_years = "" +month_val+year;
function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}
class DailySettlementReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            _notificationSystem: null,
            dateTo:tod,
            dateToShow:todShow,
            dateLimit: date_limit,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:{value:'HDFC BANK', label: 'HDFC BANK'},
            issuerBankIds:'HDFC BANK',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            model_visible : false,
            file_url: '',
            rfile: '',
            tableLoading: true,
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true,
            dateFromLimit: start_date_limit,
            mvalue: {year: new Date().getFullYear(), month: new Date().getMonth()},
            m_yr: month_years,
            tirewiseTotal:[],
            zonewiseTotal:[],
            categorywiseTotal:[],
            tirewiseIssuer:[],
            zonewiseIssuer:[],
            categorywiseIssuer:[],
            tenurewiseIssuer:[],
            fetch_data:false

        }
        this.handleClickMonthBox = this.handleClickMonthBox.bind(this);
        this.handleAMonthChange = this.handleAMonthChange.bind(this);
        this.handleAMonthDissmis = this.handleAMonthDissmis.bind(this);
    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        // this._getAllMerchants();
        // this._get_acq_banks();
        // this._get_city();
        this.tirewise(this.state.m_yr);
        this.zonewise(this.state.m_yr);
        this.categorywise(this.state.m_yr);
        this.tirewiseissuer(this.state.m_yr, this.state.issuerBankIds);
        this.zonewiseissuer(this.state.m_yr, this.state.issuerBankIds);
        this.categorywiseissuer(this.state.m_yr, this.state.issuerBankIds);
        this.tenurewiseissuer(this.state.m_yr, this.state.issuerBankIds);
        this._get_emi_issuing_banks();
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            // this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            // this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            // this._get_filtered_daily_settlement_report('','','','','', this.state.yestSend, this.state.todSend);
            // //this.unauthrize_acess();
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })

        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode);
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode);
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })

        }
        else {
            this.unauthorize_access();
        }
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'zone_wise_emi','sparcs')
    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        let reportPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
            if(permissionName.access_type=='report'){
                reportPermissions.push(permissionName.access_name);
            }
        });
        if(reportPermissions.includes("zone_wise_emi")===false){
            this.unauthorize_access();
        }

    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";

    }
    tirewise(month){
        var that = this;
        $('.dataTables_processing', $('#tierWise').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
        axios.post(config.get('API_URL') + '/reports/tirewisetotal/', {
                month: month,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {

            if ($.fn.DataTable.isDataTable('#tierWise')) {
                $('#tierWise').DataTable().destroy();
            }
            that.setState({
                tirewiseTotal: response.data.data,
                loading:false
            })
            let total = '';
            let pageTotal = '';
            $('#tierWise').DataTable({
                searching: false,
                bInfo : false,
                paging: false,
                "aaSorting": [],
                bProcessing: true,
             "footerCallback": function ( row, data, start, end, display ) {
                var api = this.api(), data;

                // Remove the formatting to get integer data for summation
                var intVal = function ( i ) {
                    return typeof i === 'string' ?
                        i.replace(/[\$,]/g, '')*1 :
                        typeof i === 'number' ?
                            i : 0;
                };

                // Total over all pages
                total = api
                    .column( 2 )
                    .data()
                    .reduce( function (a, b) {
                        return intVal(a) + intVal(b);
                    }, 0 );

                // Total over this page
                pageTotal = api
                    .column( 1, { page: 'current'} )
                    .data()
                    .reduce( function (a, b) {
                        return intVal(a) + intVal(b);
                    }, 0 );
                let pageTotalCount = api
                    .column( 2, { page: 'current'} )
                    .data()
                    .reduce( function (a, b) {
                        return intVal(a) + intVal(b);
                    }, 0 );

                // Update footer
                 $( api.column( 0 ).footer() ).html(
                    'Grand Total:'
                 );
                $( api.column( 1 ).footer() ).html(
                    ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                );
                $( api.column( 2 ).footer() ).html(
                    ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                );
            },

            });
            $('.dataTables_processing', $('#tierWise').closest('.dataTables_wrapper')).hide();
        }, 100);
        });

    }
    zonewise(month){
        var that =this;
        $('.dataTables_processing', $('#zoneWise').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
        axios.post(config.get('API_URL') + '/reports/zonewisetotal/', {
                month: month,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            if ($.fn.DataTable.isDataTable('#zoneWise')) {
                $('#zoneWise').DataTable().destroy();
            }
            that.setState({
                zonewiseTotal: response.data.data,
                loading:false
            })
            let total = '';
            let pageTotal = '';
            $('#zoneWise').DataTable({
                searching: false,
                bInfo : false,
                paging: false,
                "aaSorting": [],
                bProcessing: true,
                "footerCallback": function ( row, data, start, end, display ) {
                    var api = this.api(), data;

                    // Remove the formatting to get integer data for summation
                    var intVal = function ( i ) {
                        return typeof i === 'string' ?
                            i.replace(/[\$,]/g, '')*1 :
                            typeof i === 'number' ?
                                i : 0;
                    };

                    // Total over all pages
                    total = api
                        .column( 2 )
                        .data()
                        .reduce( function (a, b) {
                            return intVal(a) + intVal(b);
                        }, 0 );

                    // Total over this page
                    pageTotal = api
                        .column( 1, { page: 'current'} )
                        .data()
                        .reduce( function (a, b) {
                            return intVal(a) + intVal(b);
                        }, 0 );
                    let pageTotalCount = api
                        .column( 2, { page: 'current'} )
                        .data()
                        .reduce( function (a, b) {
                            return intVal(a) + intVal(b);
                        }, 0 );

                    // Update footer
                    $( api.column( 0 ).footer() ).html(
                        'Grand Total:'
                    );
                    $( api.column( 1 ).footer() ).html(
                        ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                    );
                    $( api.column( 2 ).footer() ).html(
                        ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                    );
                },

            });
            $('.dataTables_processing', $('#zoneWise').closest('.dataTables_wrapper')).hide();
        }, 100);
        });

    }
    categorywise(month){
        var that =this;
        $('.dataTables_processing', $('#categoryWise').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
        axios.post(config.get('API_URL') + '/reports/categorywisetotal/', {
                month: month,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            if ($.fn.DataTable.isDataTable('#categoryWise')) {
                $('#categoryWise').DataTable().destroy();
            }
            that.setState({
                categorywiseTotal: response.data.data,
                loading:false
            })
            let total = '';
            let pageTotal = '';
            $('#categoryWise').DataTable({
                searching: false,
                bInfo : false,
                paging: false,
                "aaSorting": [],
                bProcessing: true,
                "footerCallback": function ( row, data, start, end, display ) {
                    var api = this.api(), data;

                    // Remove the formatting to get integer data for summation
                    var intVal = function ( i ) {
                        return typeof i === 'string' ?
                            i.replace(/[\$,]/g, '')*1 :
                            typeof i === 'number' ?
                                i : 0;
                    };

                    // Total over all pages
                    total = api
                        .column( 2 )
                        .data()
                        .reduce( function (a, b) {
                            return intVal(a) + intVal(b);
                        }, 0 );

                    // Total over this page
                    pageTotal = api
                        .column( 1, { page: 'current'} )
                        .data()
                        .reduce( function (a, b) {
                            return intVal(a) + intVal(b);
                        }, 0 );
                    let pageTotalCount = api
                        .column( 2, { page: 'current'} )
                        .data()
                        .reduce( function (a, b) {
                            return intVal(a) + intVal(b);
                        }, 0 );

                    // Update footer
                    $( api.column( 0 ).footer() ).html(
                        'Grand Total:'
                    );
                    $( api.column( 1 ).footer() ).html(
                        ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                    );
                    $( api.column( 2 ).footer() ).html(
                        ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                    );
                },

            });
            $('.dataTables_processing', $('#categoryWise').closest('.dataTables_wrapper')).hide();
        }, 100);
        });

    }
    tirewiseissuer(month, issuer){
        var that = this;
        $('.dataTables_processing', $('#tierWiseissuer').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
            axios.post(config.get('API_URL') + '/reports/tirewiseissuer/', {
                    month: month,
                    issuer: issuer
                },
                {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    },

                }).then(response => {
                //console.log(response.data.data)
                if ($.fn.DataTable.isDataTable('#tierWiseissuer')) {
                    $('#tierWiseissuer').DataTable().destroy();
                }
                that.setState({
                    tirewiseIssuer: response.data.data,
                    loading:false
                })
                let total = '';
                let pageTotal = '';
                $('#tierWiseissuer').DataTable({
                    searching: false,
                    bInfo : false,
                    paging: false,
                    "aaSorting": [],
                    bProcessing: true,
                    "footerCallback": function ( row, data, start, end, display ) {
                        var api = this.api(), data;

                        // Remove the formatting to get integer data for summation
                        var intVal = function ( i ) {
                            return typeof i === 'string' ?
                                i.replace(/[\$,]/g, '')*1 :
                                typeof i === 'number' ?
                                    i : 0;
                        };

                        // Total over all pages
                        total = api
                            .column( 2 )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );

                        // Total over this page
                        pageTotal = api
                            .column( 1, { page: 'current'} )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );
                        let pageTotalCount = api
                            .column( 2, { page: 'current'} )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );

                        // Update footer
                        $( api.column( 0 ).footer() ).html(
                            'Grand Total:'
                        );
                        $( api.column( 1 ).footer() ).html(
                            ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                        );
                        $( api.column( 2 ).footer() ).html(
                            ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                        );
                    },

                });
                $('.dataTables_processing', $('#tierWiseissuer').closest('.dataTables_wrapper')).hide();
            }, 100);
        });

    }
    zonewiseissuer(month,issuer){
        var that =this;
        $('.dataTables_processing', $('#zoneWiseissuer').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
            axios.post(config.get('API_URL') + '/reports/zonewiseissuer/', {
                    month: month,
                    issuer: issuer
                },
                {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    },

                }).then(response => {
                if ($.fn.DataTable.isDataTable('#zoneWiseissuer')) {
                    $('#zoneWiseissuer').DataTable().destroy();
                }
                that.setState({
                    zonewiseIssuer: response.data.data,
                    loading:false
                })
                let total = '';
                let pageTotal = '';
                $('#zoneWiseissuer').DataTable({
                    searching: false,
                    bInfo : false,
                    paging: false,
                    "aaSorting": [],
                    bProcessing: true,
                    "footerCallback": function ( row, data, start, end, display ) {
                        var api = this.api(), data;

                        // Remove the formatting to get integer data for summation
                        var intVal = function ( i ) {
                            return typeof i === 'string' ?
                                i.replace(/[\$,]/g, '')*1 :
                                typeof i === 'number' ?
                                    i : 0;
                        };

                        // Total over all pages
                        total = api
                            .column( 2 )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );

                        // Total over this page
                        pageTotal = api
                            .column( 1, { page: 'current'} )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );
                        let pageTotalCount = api
                            .column( 2, { page: 'current'} )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );

                        // Update footer
                        $( api.column( 0 ).footer() ).html(
                            'Grand Total:'
                        );
                        $( api.column( 1 ).footer() ).html(
                            ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                        );
                        $( api.column( 2 ).footer() ).html(
                            ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                        );
                    },

                });
                $('.dataTables_processing', $('#zoneWiseissuer').closest('.dataTables_wrapper')).hide();
            }, 100);
        });

    }
    categorywiseissuer(month, issuer){
        var that =this;
        $('.dataTables_processing', $('#categoryWiseissuer').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
            axios.post(config.get('API_URL') + '/reports/categorywiseissuer/', {
                    month: month,
                    issuer:issuer
                },
                {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    },

                }).then(response => {
                if ($.fn.DataTable.isDataTable('#categoryWiseissuer')) {
                    $('#categoryWiseissuer').DataTable().destroy();
                }
                that.setState({
                    categorywiseIssuer: response.data.data,
                    loading:false
                })
                let total = '';
                let pageTotal = '';
                $('#categoryWiseissuer').DataTable({
                    searching: false,
                    bInfo : false,
                    paging: false,
                    "aaSorting": [],
                    bProcessing: true,
                    "footerCallback": function ( row, data, start, end, display ) {
                        var api = this.api(), data;

                        // Remove the formatting to get integer data for summation
                        var intVal = function ( i ) {
                            return typeof i === 'string' ?
                                i.replace(/[\$,]/g, '')*1 :
                                typeof i === 'number' ?
                                    i : 0;
                        };

                        // Total over all pages
                        total = api
                            .column( 2 )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );

                        // Total over this page
                        pageTotal = api
                            .column( 1, { page: 'current'} )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );
                        let pageTotalCount = api
                            .column( 2, { page: 'current'} )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );

                        // Update footer
                        $( api.column( 0 ).footer() ).html(
                            'Grand Total:'
                        );
                        $( api.column( 1 ).footer() ).html(
                            ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                        );
                        $( api.column( 2 ).footer() ).html(
                            ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                        );
                    },

                });
                $('.dataTables_processing', $('#categoryWiseissuer').closest('.dataTables_wrapper')).hide();
            }, 100);
        });

    }
    tenurewiseissuer(month,issuer){
        var that =this;
        $('.dataTables_processing', $('#tenureWiseissuer').closest('.dataTables_wrapper')).show();
        setTimeout(function(){
            axios.post(config.get('API_URL') + '/reports/tenurewiseissuer/', {
                    month: month,
                    issuer:issuer
                },
                {
                    headers: {
                        Authorization: ` ${localStorage.usertoken}`
                    },

                }).then(response => {
                if ($.fn.DataTable.isDataTable('#tenureWiseissuer')) {
                    $('#tenureWiseissuer').DataTable().destroy();
                }
                that.setState({
                    tenurewiseIssuer: response.data.data,
                    loading:false
                })
                let total = '';
                let pageTotal = '';
                $('#tenureWiseissuer').DataTable({
                    searching: false,
                    bInfo : false,
                    //paging: false,
                    "aaSorting": [],
                    bProcessing: true,
                    "footerCallback": function ( row, data, start, end, display ) {
                        var api = this.api(), data;

                        // Remove the formatting to get integer data for summation
                        var intVal = function ( i ) {
                            return typeof i === 'string' ?
                                i.replace(/[\$,]/g, '')*1 :
                                typeof i === 'number' ?
                                    i : 0;
                        };

                        // Total over all pages
                        total = api
                            .column( 2 )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );

                        // Total over this page
                        pageTotal = api
                            .column( 1, { page: 'current'} )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );
                        let pageTotalCount = api
                            .column( 2, { page: 'current'} )
                            .data()
                            .reduce( function (a, b) {
                                return intVal(a) + intVal(b);
                            }, 0 );

                        // Update footer
                        $( api.column( 0 ).footer() ).html(
                            'Grand Total:'
                        );
                        $( api.column( 1 ).footer() ).html(
                            ''+formatNumber(parseFloat(pageTotal).toFixed( 2 )) +''
                        );
                        $( api.column( 2 ).footer() ).html(
                            ''+formatNumber(parseFloat(pageTotalCount).toFixed( 2 )) +''
                        );
                    },

                });
                $('.dataTables_processing', $('#tenureWiseissuer').closest('.dataTables_wrapper')).hide();
            }, 100);
        });

    }

    downLoadZoneWiseEmiReport (type, e){
        var fname = 'Consolidated';
        if(type=='by issuer')   {
            fname = "Issuer";
        }
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
           month: this.state.m_yr,
           issuer:this.state.issuerBankIds,
           type: type,
           download: true
        };

            let xhrBank = $.ajax({
                url:config.get('API_URL')+ "/reports/zone-wise-emi-download",
                type: "POST",
                data: postData,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
//                 xhrFields: {
//                     responseType: 'blob'
//                 },
                success: function (response, status, xhr) {
                    this.copyZoneFile(response.data,fname);
                    this.setState({
                        fetch_data:true
                    })
                }.bind(this)
            });
            this.setState({
                xhrBank: xhrBank
            })

    }

    copyZoneFile(remotePath,fname){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
                type: "POST",
                data: postData,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                xhrFields: {
                    responseType: 'blob'
                },
                success: function (response, status, xhr) {
                    let blob = new Blob([response], {
                        type: "octet/stream"
                    });
                    let fileName = fname+timestamp+'.xlsx';
                    let rfile = fileName.replace(/\"/g, "");
                    //console.log(fileName)
                    //let a = document.createElement('a');
                    let url = window.URL.createObjectURL(blob);
                    // a.href = url;
                    // a.download = rfile;
                    // a.click();
                    // window.URL.revokeObjectURL(url);
                    this.setState({
                        is_download: true,
                        file_url: url,
                        rfile: rfile
                    })
                }.bind(this)
            });
            this.setState({
                xhrBank: xhrBank
            })

    }

    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }


    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: []
        });
        this._get_filtered_daily_settlement_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }

    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value == cids.value);
                    this.state.chainList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: []
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        }

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList
            })
        });
    }
    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL')+'/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }

    changeStore(login_type, optionSelected) {
        let value='';
        let sidArray = [];
        if(optionSelected.length<1){
            value = null;
            sidArray = '';
        }
        else{
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)

                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value == sids.value);
                    this.state.storeList.move(index, 0).join(',');

                }
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue:optionSelected
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, sidArray, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend);
    }
    _get_acq_banks(){
        axios.get(config.get('API_URL')+'/reports/acq-banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    change_acq_banks(optionSelected){ //console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected.length<1){
            value = null;
            acqBankArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        this.setState({
            acqBankIds:acqBankArray,
            acqBankValue:optionSelected,
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,
            this.state.yestSend, this.state.todSend);
    }
    _get_city(){
        axios.get(config.get('API_URL')+'/reports/get-city/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((city, index) => {
                    this.state.cityLists.push({value: city.city_name, label: city.city_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeCity(optionSelected){ //console.log(optionSelected);
        let value='';
        let cityArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                cityArray.push(mids.value)
                var index = this.state.cityLists.findIndex(obj => obj.value==mids.value);
                this.state.cityLists.move(index,0).join(',');
            });
        }
        this.setState({
            cityIds:cityArray,
            cityValue:optionSelected,
        });
        this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, cityArray,
            this.state.yestSend, this.state.todSend)
    }
    _get_emi_issuing_banks(){
        axios.get(config.get('API_URL')+'/reports/all_emi_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    this.state.issuerBankList.push({value: issuBank.issuer_bank_display_name, label: issuBank.issuer_bank_display_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }


    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this._get_filtered_daily_settlement_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
                this.state.yestSend, this.state.todSend)
        }
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    handleClickMonthBox (e) {
        this.refs.pickAMonth.show()
    }
    handleAMonthChange(value, text) {
        var month = '';
        if(text.toString().length==1){
            month = "" +0+text;
        }
        else {
            month = text;
        }

        var month_year = "" +month+value;
        this.setState({
            m_yr: month_year,
            mvalue: {year: value, month: text}
        });
        this.tirewise(month_year);
        this.zonewise(month_year);
        this.categorywise(month_year);
        this.tirewiseissuer(month_year, this.state.issuerBankIds);
        this.zonewiseissuer(month_year, this.state.issuerBankIds);
        this.categorywiseissuer(month_year, this.state.issuerBankIds);
        this.tenurewiseissuer(month_year, this.state.issuerBankIds);
        this.handleAMonthDissmis(this.state.mvalue);
    }
    handleAMonthDissmis(value) {
        // this.setState({
        //     mvalue: value
        // });
    }

    change_issuer(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        // alert(value);
        // let issuArray = [];
        // if(optionSelected===null){
        //     value = null;
        // }
        // else{
        //     optionSelected.map((mids, i) => {
        //         issuArray.push(mids.value)
        //         var index = this.state.issuerBankList.findIndex(obj => obj.value==mids.value);
        //         this.state.issuerBankList.move(index,0).join(',');
        //     });
        // }
        this.setState({
            issuerBankIds:value,
            issuerBankValue:optionSelected,
        });
        this.tirewiseissuer(this.state.m_yr, value);
        this.zonewiseissuer(this.state.m_yr, value);
        this.categorywiseissuer(this.state.m_yr, value);
        this.tenurewiseissuer(this.state.m_yr, value);


    }
    render() {
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', to: 'To',
        };
        const mvalue = this.state.mvalue
        ;
        const makeText = m => {
            if (m && m.year && m.month) return (pickerLang.months[m.month-1] + '. ' + m.year);
            return '?'
        };
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        const tireWiseTotal = this.state.tirewiseTotal.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data.Tier}</td>
                    <td className="align-right">{data['Value (Rs, lakhs)']}</td>
                    <td className="align-right">{data.Count}</td>

                </tr>
            )
        });
        const zoneWiseTotal = this.state.zonewiseTotal.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data.Zone}</td>
                    <td className="align-right">{data['Value (Rs, lakhs)']}</td>
                    <td className="align-right">{data.Count}</td>

                </tr>
            )
        });
        const categoryWiseTotal = this.state.categorywiseTotal.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data.Category}</td>
                    <td className="align-right">{data['Value (Rs, lakhs)']}</td>
                    <td className="align-right">{data.Count}</td>

                </tr>
            )
        });
        const tireWiseissuer = this.state.tirewiseIssuer.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data.Tier}</td>
                    <td className="align-right">{data['Value (Rs, lakhs)']}</td>
                    <td className="align-right">{data.Count}</td>
                    <td className="align-right">{data['Percentage Share']}{data['Percentage Share']!=''?'%':null}</td>
                </tr>
            )
        });
        const zoneWiseIssuer = this.state.zonewiseIssuer.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data.Zone}</td>
                    <td className="align-right">{data['Value (Rs, lakhs)']}</td>
                    <td className="align-right">{data['By value']}{data['By value']!=''?'%':null}</td>
                    <td className="align-right">{data.Count}</td>
                    <td className="align-right">{data['By count']}{data['By count']!=''?'%':null}</td>
                </tr>
            )
        });
        const categoryWiseIssuer = this.state.categorywiseIssuer.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data.Category}</td>
                    <td className="align-right">{data['Value (Rs, lakhs)']}</td>
                    <td className="align-right">{data.Count}</td>
                    <td className="align-right">{data['Percentage Share']}{data['Percentage Share']!=''?'%':null}</td>
                </tr>
            )
        });
        const tenureWiseIssuer = this.state.tenurewiseIssuer.map((data, index) => {

            return (
                <tr key={index}>
                    <td>{data.Merchant}</td>
                    <td>{data.Chain}</td>
                    <td>{data.Store}</td>
                    <td className="align-right">{data['3 months']}</td>
                    <td className="align-right">{data['6 months']}</td>
                    <td className="align-right">{data['9 months']}</td>
                    <td className="align-right">{data['12 months']}</td>
                    <td className="align-right">{data['Grand Total']}</td>
                </tr>
            )
        });


        return(
           
            <div className="content-invoice">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Zone wise EMI Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    {/*<div className="row">*/}
                                    <div className="col-lg-1 col-md-1 col-sm-2 col-xs-5 pull-left">
                                        <p  style={{padding:'10px 0px 0px 20px',color:'#9A9A9A'}}>month:</p>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-5">
                                        <Picker
                                            ref="pickAMonth"
                                            theme="light"
                                            years={{
                                                max: {
                                                    year: new Date().getFullYear(),
                                                    month: new Date().getMonth()
                                                },
                                                min: {year: 2019, month: 4}
                                            }}
                                            // years={new Date().getFullYear()}
                                            value={mvalue}
                                            lang={pickerLang.months}
                                            onChange={this.handleAMonthChange}
                                            onDismiss={this.handleAMonthDissmis}
                                        >
                                            <MonthBox value={makeText(mvalue)} onClick={this.handleClickMonthBox} />
                                        </Picker>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    {/*{this.state.merchant_list_box ===true?*/}
                                    {/*    <div className="col-md-2 filter-bottom5 padd-5">*/}
                                    {/*        <label>Merchants</label>*/}
                                    {/*        <ReactMultiSelectCheckboxes name="merchants"*/}
                                    {/*            isMulti*/}
                                    {/*            value={this.state.merchantValue}*/}
                                    {/*            styles={customStyles} className="report-listbox"*/}
                                    {/*            isClearable={false}*/}
                                    {/*            onChange={this.changeMerchant.bind(this,'')}*/}
                                    {/*            options={this.state.merchantList}*/}
                                    {/*            placeholderButtonLabel="Select [Merchant]"*/}
                                    {/*        />*/}

                                    {/*        <div className="clearfix"></div>*/}
                                    {/*    </div> : null}*/}
                                    {/*{this.state.chain_list_box===true?*/}
                                    {/*    <div className="col-md-2 filter-bottom5 padd-5">*/}
                                    {/*        <label> Chain </label>*/}
                                    {/*        <ReactMultiSelectCheckboxes name="chain"*/}
                                    {/*            isMulti*/}
                                    {/*            components={{ MenuList }}*/}
                                    {/*            value={this.state.chainValue}*/}
                                    {/*            styles={customStyles} className="report-listbox"*/}
                                    {/*            isClearable={false}*/}
                                    {/*            onChange={this.changeChain.bind(this,'')}*/}
                                    {/*            options={this.state.chainList}*/}
                                    {/*            placeholderButtonLabel="Select [Chain]"*/}
                                    {/*        />*/}
                                    {/*        <div className="clearfix"></div>*/}
                                    {/*    </div>: null }*/}
                                    {/*{this.state.store_list_box===true?*/}
                                    {/*    <div className="col-md-2 filter-bottom5 padd-5">*/}
                                    {/*        <label> Store </label>*/}
                                    {/*        <ReactMultiSelectCheckboxes name="store"*/}
                                    {/*                                    isMulti*/}
                                    {/*                                    isLoading={this.state.is_store_loading}*/}
                                    {/*                                    components={{ MenuList }}*/}
                                    {/*                                    value={this.state.storeValue}*/}
                                    {/*                                    styles={customStyles} className="report-listbox"*/}
                                    {/*                                    isClearable={false}*/}
                                    {/*                                    onChange={this.changeStore.bind(this, '')}*/}
                                    {/*                                    options={this.state.storeList}*/}
                                    {/*                                    placeholderButtonLabel="Select [Store]"*/}
                                    {/*        />*/}
                                    {/*        <div className="clearfix"></div>*/}
                                    {/*    </div>: null }*/}

                                    {/*    <div className="clearfix"></div>*/}
                                    {/*</div>*/}
                                    {/*<div className="gap_ver"></div>*/}
                                    {/*<div className="row">*/}
                                    {/*{this.state.acq_bank_list_box===true?*/}
                                    {/*    <div className="col-md-2 filter-bottom5 padd-5">*/}
                                    {/*        <label>Acquirer:</label>*/}
                                    {/*        <ReactMultiSelectCheckboxes name="acqurier"*/}
                                    {/*            isMulti*/}
                                    {/*            value={this.state.acqBankValue}*/}
                                    {/*            styles={customStyles} className="report-listbox"*/}
                                    {/*            isClearable={false}*/}
                                    {/*            onChange={this.change_acq_banks.bind(this)}*/}
                                    {/*            options={this.state.acqBankList}*/}
                                    {/*            placeholderButtonLabel="Select [Acquirer]"*/}
                                    {/*        />*/}
                                    {/*        <div className="clearfix"></div>*/}
                                    {/*    </div> : null }*/}
                                        {/*<div className="col-md-3">*/}
                                        {/*    <label> Issuer: </label>*/}
                                        {/*    <ReactMultiSelectCheckboxes name="issuer"*/}
                                        {/*            isMulti*/}
                                        {/*            value={this.state.issuerBankValue}*/}
                                        {/*            styles={customStyles} className="report-listbox"*/}
                                        {/*            isClearable={false}*/}
                                        {/*            onChange={this.changeChain.bind(this,'')}*/}
                                        {/*            options={this.state.issuerBankList}*/}
                                        {/*            placeholderButtonLabel="Select[Issuer]"*/}
                                        {/*    />*/}
                                        {/*    <div className="clearfix"></div>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-md-2 filter-bottom5 padd-5">*/}
                                        {/*    <label> City: </label>*/}
                                        {/*    <ReactMultiSelectCheckboxes name="city"*/}
                                        {/*            isMulti*/}
                                        {/*            components={{ MenuList }}*/}
                                        {/*            value={this.state.cityValue}*/}
                                        {/*            styles={customStyles} className="report-listbox"*/}
                                        {/*            isClearable={false}*/}
                                        {/*            onChange={this.changeCity.bind(this)}*/}
                                        {/*            options={this.state.cityLists}*/}
                                        {/*            placeholderButtonLabel="Select [City]"*/}
                                        {/*    />*/}
                                        {/*    <div className="clearfix"></div>*/}
                                        {/*</div>*/}

                                    {/*</div>*/}
                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="col-md-8 emi-zone-head">Consolidated</div>
                                        <div className="col-md-4 pull-right">
                                            <a href="#" className="exportButton" role="button" onClick={this.downLoadZoneWiseEmiReport.bind(this, 'Consolidated')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="clearfix bootom5"></div>
                                        <div className="col-md-4">
                                            <div className="content-tdetails-table table-full-width marginTop0">
                                                <div className="text-center font-12">TOTAL TIER WISE TRANSACTION</div>
                                                <table id="tierWise" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th>Tier</th>
                                                        <th>Value (Rs, lakhs)</th>
                                                        <th>Count</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {tireWiseTotal}
                                                    </tbody>
                                                    {/*<tfoot>*/}
                                                    {/*<tr>*/}
                                                    {/*    <th></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}

                                                    {/*</tr>*/}
                                                    {/*</tfoot>*/}

                                                </table>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="content-tdetails-table table-full-width marginTop0">
                                                <div className="text-center font-12">TOTAL ZONE WISE TRANSACTION</div>
                                                <table id="zoneWise" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th>Zone</th>
                                                        <th>Value (Rs, lakhs)</th>
                                                        <th>Count</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {zoneWiseTotal}
                                                    </tbody>
                                                    {/*<tfoot>*/}
                                                    {/*<tr>*/}
                                                    {/*    <th></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}

                                                    {/*</tr>*/}
                                                    {/*</tfoot>*/}
                                                </table>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="content-tdetails-table table-full-width marginTop0">
                                                <div className="text-center font-12">CATEGORY WISE TRANSACTION</div>
                                                <table id="categoryWise" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th>Category</th>
                                                        <th>Value (Rs, lakhs)</th>
                                                        <th>Count</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {categoryWiseTotal}
                                                    </tbody>
                                                    {/*<tfoot>*/}
                                                    {/*<tr>*/}
                                                    {/*    <th></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*</tr>*/}
                                                    {/*</tfoot>*/}
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-8 emi-zone-head">By Issuer</div>
                                        <div className="col-md-4 pull-right">
                                            <a href="#" className="exportButton" role="button" onClick={this.downLoadZoneWiseEmiReport.bind(this, 'by issuer')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>
                                        <div className="gap_ver"></div>
                                        <div className="col-lg-1 col-md-1 col-sm-2 col-xs-5 pull-left">
                                            <p  style={{padding:'10px 0px 0px 20px',color:'#9A9A9A'}}>Issuer:</p>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-5">
                                            <Select name="issuer"

                                                                        components={{ MenuList }}
                                                //isLoading = {this.state.acq_loading}
                                                                        value={this.state.issuerBankValue}
                                                                        styles={customStyles} className="report-listbox"
                                                                        isClearable={false}
                                                                        onChange={this.change_issuer.bind(this)}
                                                                        options={this.state.issuerBankList}
                                                                        // placeholderButtonLabel="Select [issuer]"
                                            />
                                        </div>
                                        {/*<div className="col-lg-2 col-md-2 col-sm-2 col-xs-5">*/}
                                        {/*    <a href="#" className="exportButton-out" role="button" onClick={this.downLoadDailySettlementReport.bind(this)}>*/}
                                        {/*        <i className="fa fa-download" aria-hidden="true"></i>*/}
                                        {/*        Download Excel*/}
                                        {/*    </a>*/}
                                        {/*</div>*/}
                                        <div className="clearfix"></div>
                                        <div className="col-md-4">
                                            <div className="content-tdetails-table table-full-width marginTop0">
                                                <div className="text-center font-12">TOTAL TIER WISE TRANSACTION</div>
                                                <table id="tierWiseissuer" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th>Tier</th>
                                                        <th>Value (Rs, lakhs)</th>
                                                        <th>Count</th>
                                                        <th>Percentage Share</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {tireWiseissuer}
                                                    </tbody>
                                                    {/*<tfoot>*/}
                                                    {/*<tr>*/}
                                                    {/*    <th></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*</tr>*/}
                                                    {/*</tfoot>*/}
                                                </table>
                                            </div>
                                        </div>

                                        <div className="col-md-4">
                                            <div className="content-tdetails-table table-full-width marginTop0">
                                                <div className="text-center font-12">TOTAL ZONE WISE TRANSACTION</div>
                                                <table id="zoneWiseissuer" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th>Zone</th>
                                                        <th>Value (Rs, lakhs)</th>
                                                        <th>By value (%)</th>
                                                        <th>Count</th>
                                                        <th>By Count (%)</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {zoneWiseIssuer}
                                                    </tbody>
                                                    {/*<tfoot>*/}
                                                    {/*<tr>*/}
                                                    {/*    <th></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*</tr>*/}
                                                    {/*</tfoot>*/}
                                                </table>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="content-tdetails-table table-full-width marginTop0">
                                                <div className="text-center font-12">CATEGORY WISE TRANSACTION</div>
                                                <table id="categoryWiseissuer" className="table table-striped table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th>Category</th>
                                                        <th>Value (Rs, lakhs)</th>
                                                        <th>Count</th>
                                                        <th>Percentage Share</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {categoryWiseIssuer}
                                                    </tbody>
                                                    {/*<tfoot>*/}
                                                    {/*<tr>*/}
                                                    {/*    <th></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*    <th className="align-right"></th>*/}
                                                    {/*</tr>*/}
                                                    {/*</tfoot>*/}
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <div className="text-center font-12">EMI Tenor-wise</div>
                                        <table id="tenureWiseissuer" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store</th>
                                                <th>12 Months</th>
                                                <th>3 Months</th>
                                                <th>6 Months</th>
                                                <th>9 Months</th>
                                                <th>Grand Total</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {tenureWiseIssuer}
                                            </tbody>
                                        </table>
                                    </div>

                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                                              
        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(DailySettlementReport)